module.exports = __webpack_public_path__ + "fonts/b072ddfa4ebaa7a3dab4e8321fe69bec.svg";